<template>
    <ul class="footer-links">
        <li><img src="@/assets/images/social/location.png" alt="Location"> {{ $t('footer.address') }}</li>
        <li><img src="@/assets/images/social/phone.png" alt="Phone"> <span class="phone_number">+966 53 190 3600</span>
        </li>
        <li><img src="@/assets/images/social/message.png" alt="Email"> info@furqn.com</li>
    </ul>
</template>
<style scoped>
.footer-links {
    list-style: none;
    padding: 0;
}

.footer-links li {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.footer-links a {
    text-decoration: none;
    color: #393735;
    transition: 0.3s;
    font-size: 18px;
    font-weight: 400;
}

.phone_number {
    direction: ltr !important;
}
</style>